import { apiFetcher } from '@/api/api'
import { useCacheSWR } from '@/api/swrCache'
import { useMemo } from 'react'

// 获取投注记录
export function useBetRecordList(filters: any) {
  const cacheKey: [string, Record<string, any>] = useMemo(() => ['bet-records', filters], [filters])
  
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/game/api/v1/record/betRecordList',
        type: 'post'
      },
      {
        arg: {...filters}
      }
    )
  }
  const result = useCacheSWR(cacheKey, fetcher, {dedupingInterval: 5 * 1000, author: true})

  const list = result.data?.data?.gameRecordList ?? []
  const totalRecord = result.data?.data?.totalRecord ?? 0
  const totalPage =result.data?.data?.totalPage ?? Math.ceil(totalRecord / filters.pageSize)
  return{
    ...result,
    list,
    totalRecord,
    totalPage
  }
}

// 获取投注的统计数据
export function useQueryBetRecordTotal(params: any) {
  const cacheKey: [string, Record<string, any>] = useMemo(() => ['bet-records-total', params], [params])
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/game/api/v1/record/betRecordTotal',
        type: 'post'
      },
      {
        arg: {...params}
      }
    )
  }
  const result = useCacheSWR(cacheKey, fetcher, {dedupingInterval: 5 * 1000, author: true})

  const data = result.data?.data
  return{
    ...result,
    data
  }
}



/// 获取场馆数据
export function useQueryVenueList(params: any) {
  const fetcher = () => {
    return apiFetcher({
      path: '/game/api/v1/venue/webList'
    })
  }

  const result = useCacheSWR('useQueryVenueList', fetcher, {
    dedupingInterval: 60 * 60 * 1000
  })

  return result
}